import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";

// Assets
import "~/assets/sass/pages/mypage/admin/connect.scss";
import CompanyList from "./components/CompanyList";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { ConnectPageIcon } from "~/assets/svg/PageIntroIcon";

const AdminConnectPage = () => {
	const [sampleModal, setSampleModal] = useState(false);
	const [confirmList, setConfirmList] = useState([]);
	const [disconnectTarget, setDisconnectTarget] = useState("");
	const connectionRequest = useRequest("get", "/vc/admin/connect");
	const disConnectRequest = useRequest("post", "/vc/admin/connect/reject");

	useEffect(() => {
		connectionRequest.singleCall();
	});

	useEffect(() => {
		switch (connectionRequest.state) {
			case API_STATE.done:
				const newData = connectionRequest.response.data;
				setConfirmList(newData);
				break;
			case API_STATE.error:
				console.log("error", connectionRequest.error);
				break;
			default:
				break;
		}
	}, [connectionRequest.state, connectionRequest.response, connectionRequest.error]);

	const disConnect = () => {
		setSampleModal(false);
		setDisconnectTarget("");
		disConnectRequest.call(disconnectTarget, "path");
	};

	useEffect(() => {
		switch (disConnectRequest.state) {
			case API_STATE.done:
				connectionRequest.call();
				break;
			case API_STATE.error:
				console.log("error", connectionRequest.error);
				break;
			default:
				break;
		}
	}, [disConnectRequest.state, disConnectRequest.response, disConnectRequest.error]);

	return (
		<NavbarAndSidebarLayout menu={["admin", "connect"]} type="myPage">
			<PageHeader />
			<div className="pageIntro">
				<ConnectPageIcon />
				<div className="content">
					<h3>
						기업과 <b>투자포트폴리오를 연결</b>합니다.
					</h3>
					<p>
						투자사에서 관리하고 있는 스타트업들의 투자 포트폴리오를
						<br />
						간편하게 연결하고 관리하세요.
					</p>
				</div>
			</div>
			<CompanyList {...{ setSampleModal, confirmList, setDisconnectTarget }} />
			{/*연결취소 버튼을 눌렀을때 모달*/}
			<AlertTemplate
				alertModalState={sampleModal}
				setAlertModalToggle={setSampleModal}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">연결을 취소하시겠습니까?</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" onClick={() => disConnect()} color="primary">
						예
					</button>
					<button
						className="btn__solid"
						onClick={() => setSampleModal(false)}
						color="gray"
					>
						아니오
					</button>
				</div>
			</AlertTemplate>
		</NavbarAndSidebarLayout>
	);
};

export default AdminConnectPage;
